import request from '@utils/request.js'
// const baseUrl = 'http://183.162.251.135:16000/api/'
const login = (parmars = {}) => request.post('auth/rest/user/login', parmars)
// const getitemlist = (parmars = {}) => request.get('/auth/rest/user/get_page',{parmars})


export{
    login,
}